import { type ClassValue, clsx } from "clsx";
import type * as React from "react";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Gives a control focus when it is pressed with a pointer.
 *
 * Safari and Firefox on macOS do not focus a `<button>` on click, so
 * `document.activeElement` stays on `<body>`. Any overlay opened by that click
 * then records `<body>` as the element to return to, and closing it drops focus
 * to the top of the page instead of back to the control.
 *
 * This does not show a focus ring: `:focus-visible` still does not match for
 * pointer input.
 */
export function focusOnPointerDown(
  event: React.PointerEvent<HTMLElement>,
): void {
  if (event.currentTarget !== document.activeElement) {
    event.currentTarget.focus({ preventScroll: true });
  }
}
